export default __webpack_public_path__ + "static/media/designLogo.e365a87c.png";